import { IChatItem } from "../~store/models/ChatItem";

import './ChatItem.css';
import { ChannelType } from "src/app/channel/~store/models/enums/ChannelType";

interface IChatItemProps {
    chatItem: IChatItem,
    isSelected: boolean,
    operatorId: number
  }

const ChatItem  = (props: IChatItemProps) => {
    const _getNotAnsweredMessageClassName = (): string => {
        const hasUnanswered = props.chatItem.notAnsweredClientMessagesCount != 0;
        const isMyChat = props.chatItem.operatorId === props.operatorId;

        if (hasUnanswered && isMyChat) 
            return "chat-panel__not-answered-messages-count-chat-with-not-answered-messages";
        if (props.chatItem.invitedOperatorsId?.indexOf(props.operatorId) > -1)
            return "chat-panel__not-answered-messages-count-withme-chat";
        if (!hasUnanswered && isMyChat) 
            return "chat-panel__not-answered-messages-count-chat-without-not-answered-messages";
        return "chat-panel__not-answered-messages-count-chat-without-not-answered-messages";
    };

    let channel = "channel-type-";
    switch(props.chatItem.channelType)
    {
        case ChannelType.Telegram:
            channel += "telegram"
            break;
        case ChannelType.Viber:
            channel += "viber"
            break;
        case ChannelType.Vk:
            channel += "vk"
            break;
        case ChannelType.Widget:
            channel += "widget"
            break;
        case ChannelType.Facebook:
            channel += "facebook"
            break;
        case ChannelType.WeChat:
            channel += "wechat"
            break;
        case ChannelType.Instagram:
            channel += "instagram"
            break;
        case ChannelType.UniformWidget:
            channel += "uniformwidget"
            break;
        case ChannelType.EdnaWhatsApp:
            channel += "ednawhatsapp"
            break;
        case ChannelType.WhatsApp:
            channel += "whatsapp"
            break;
        case ChannelType.TelegramPrivate:
            channel += "telegram-private"
            break;
        case ChannelType.SendPulse:
            channel += "sendpulse"
            break;
    }
    return (
        <div
            className={(props.isSelected ? "chat-panel__selected-chat " : "") + "chat-item " + channel}
            data-testid="chat-row"
            data-chat-id={props.chatItem?.chatId}
            data-chat-selected={props.isSelected ? "true" : "false"}>
            <img className="chat-panel__chat-item__image"></img>
            <div
                className={"chat-panel__chat-item__count " + _getNotAnsweredMessageClassName()}
                data-testid="chat-unanswered-count">
                {props.chatItem.notAnsweredClientMessagesCount <= 99 ? props.chatItem.notAnsweredClientMessagesCount : "99+"}
            </div>
            <div className="chat-panel__chat-item__chat-id" data-testid="chat-id">#{props.chatItem.chatId}</div>
        </div>
    );
}


export default ChatItem;